import { track } from './send'

export default class Input {
  add (entry) {
    entry.el.addEventListener('input', function () {
      track([entry.el.trackParams])
    })
  }
}
